import React from "react";
import { Building2, ArrowUpRight, ShieldCheck } from "lucide-react";
import { AUDIENCES, POLICIES } from "../lib/aboutData";

export const WhoWeServe = () => (
  <section className="audience-section section-pad" data-testid="who-we-serve-section">
    <div className="container-x">
      <span className="accent-bar mb-3" />
      <h2 className="font-heading text-3xl md:text-4xl font-bold text-navy">Who We Serve</h2>
      <div className="audience-grid mt-10">
        {AUDIENCES.map((audience, index) => (
          <div key={audience} className="audience-card" data-testid={`audience-${index}`}>
            <Building2 size={21} strokeWidth={1.5} aria-hidden="true" />
            <span>{audience}</span><ArrowUpRight size={15} aria-hidden="true" className="audience-accent" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const PolicyProcedures = () => (
  <section className="policy-section section-pad" data-testid="policy-procedures-section">
    <div className="container-x">
      <div className="policy-heading">
        <div><span className="accent-bar mb-3" /><h2 className="font-heading text-3xl md:text-4xl font-bold text-navy">Policy and Procedures</h2></div>
        <ShieldCheck size={40} strokeWidth={1.3} className="text-brandred" aria-hidden="true" />
      </div>
      <ol className="policy-list mt-10">
        {POLICIES.map((policy, index) => (
          <li key={policy.title} className="policy-row" data-testid={`policy-${index + 1}`}>
            <span className="policy-number" aria-hidden="true">0{index + 1}</span>
            <div><h3 className="font-heading font-bold uppercase text-navy" data-testid={`policy-title-${index + 1}`}>{index + 1}. {policy.title}</h3><p className="text-sm text-navy/80 leading-relaxed mt-3" data-testid={`policy-text-${index + 1}`}>{policy.text}</p></div>
          </li>
        ))}
      </ol>
    </div>
  </section>
);